import { flushSync } from 'react-dom';

const BUBBLE_DURATION_MS = 520;

function getBubbleOrigin(event) {
  if (
    event
    && typeof event.clientX === 'number'
    && typeof event.clientY === 'number'
  ) {
    return { x: event.clientX, y: event.clientY };
  }
  return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
}

function getBubbleRadius(x, y) {
  return Math.hypot(
    Math.max(x, window.innerWidth - x),
    Math.max(y, window.innerHeight - y),
  );
}

/**
 * Applies a theme change with a circular "bubble" reveal when the browser
 * supports View Transitions. Falls back to an instant swap otherwise.
 */
export function runThemeBubbleTransition(event, applyChange) {
  if (typeof applyChange !== 'function') return;

  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  const canAnimate = typeof document.startViewTransition === 'function';

  if (reduceMotion || !canAnimate) {
    applyChange();
    return;
  }

  const { x, y } = getBubbleOrigin(event);
  const endRadius = getBubbleRadius(x, y);

  const transition = document.startViewTransition(() => {
    flushSync(() => {
      applyChange();
    });
  });

  transition.ready
    .then(() => {
      document.documentElement.animate(
        {
          clipPath: [
            `circle(0px at ${x}px ${y}px)`,
            `circle(${endRadius}px at ${x}px ${y}px)`,
          ],
        },
        {
          duration: BUBBLE_DURATION_MS,
          easing: 'ease-in-out',
          pseudoElement: '::view-transition-new(root)',
        },
      );
    })
    .catch(() => {
      /* Transition aborted — theme change already applied via flushSync. */
    });
}
